import useWindowDimensions from 'utils/hooks/useWindowDimensions'
import Loading from 'components/loading/Loading'

const FullPageLoading = () => {
  const { height } = useWindowDimensions()
  return (
    <div style={{ height: height - 136 }}>
      <Loading />
    </div>
  )
}
export default FullPageLoading
